import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="min-h-screen flex items-center justify-center bg-[#070707] text-[#F7F1E8] px-6">
      <div className="text-center max-w-lg">
        <div className="eyebrow text-[#C99A45]">404 · Page Not Found</div>
        <h1 className="font-serif-display text-5xl md:text-7xl mt-4">
          A frame that doesn’t exist.
        </h1>
        <p className="mt-6 text-[#F7F1E8]/70 leading-relaxed">
          The page you’re looking for has wandered off the storyboard. Let’s
          take you back to the beginning.
        </p>
        <Link to="/" className="btn-gold mt-10" data-testid="notfound-home-btn">
          Return Home
        </Link>
      </div>
    </section>
  );
}
